import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {CurveGeometryAttributeSetRecordInput} from "#template/nodes/geometry-graph/attribute-set/attribute-set-record-input/curve-geometry-attribute-set-record-input"
import {CurveGeometryAttributeSetCurveLikeInput} from "#template/nodes/geometry-graph/attribute-set/curve-geometry-attribute-set-curve-like-input"
import type {CurveGeometryAttributeSetRecordInputParameters} from "#template/nodes/geometry-graph/attribute-set/attribute-set-record-input/curve-geometry-attribute-set-record-input"
import type {CurveGeometryAttributeSetCurveLikeInputParameters} from "#template/nodes/geometry-graph/attribute-set/curve-geometry-attribute-set-curve-like-input"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {IModifyTemplateGraph} from "#template/interactions"
import type {CurveGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {AttributeSetParameters} from "#template/nodes/geometry-graph/attribute-set/attribute-set-builder/geometry-attribute-set-builder-node"
import {GeometryAttributeSetBuilderNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-builder/geometry-attribute-set-builder-node"

export type CurveGeometryAttributeSetParameters = AttributeSetParameters<CurveGeometryAttributeSetRecordInput | CurveGeometryAttributeSetCurveLikeInput>

export interface SetCurveGeometryAttributeSetInput {
    setObjectLikeInput(parameters: CurveGeometryAttributeSetCurveLikeInputParameters | null, modifyTemplateGraph: IModifyTemplateGraph): void
    setRecordInput(parameters: CurveGeometryAttributeSetRecordInputParameters | null, modifyTemplateGraph: IModifyTemplateGraph): void
}

const definition: TemplateNodeDefinition<CurveGeometryAttributeSetParameters> = {
    nodeClass: "CurveGeometryAttributeSet",
    validation: {
        parameters: z.object({
            name: z.string(),
            input: z.union([graphNode(CurveGeometryAttributeSetRecordInput), graphNode(CurveGeometryAttributeSetCurveLikeInput)]),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryAttributeSet
    extends GeometryAttributeSetBuilderNode<1, CurveGeometryAttributeSetRecordInput | CurveGeometryAttributeSetCurveLikeInput>
    implements CurveGeometryAttributeSetLikeNode, SetCurveGeometryAttributeSetInput
{
    get [curveGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
    setObjectLikeInput(parameters: CurveGeometryAttributeSetCurveLikeInputParameters | null, modifyTemplateGraph: IModifyTemplateGraph): void {
        modifyTemplateGraph.modifyTemplateGraph(() =>
            this.updateParameters({input: new CurveGeometryAttributeSetCurveLikeInput({parameters: parameters ? {...parameters} : {curve: null}})}),
        )
    }

    setRecordInput(parameters: CurveGeometryAttributeSetRecordInputParameters | null, modifyTemplateGraph: IModifyTemplateGraph): void {
        modifyTemplateGraph.modifyTemplateGraph(() =>
            this.updateParameters({input: new CurveGeometryAttributeSetRecordInput({parameters: parameters ? {...parameters} : {record: {}}})}),
        )
    }
}
